import React, { useState } from "react";

import { toast } from "sonner";
const ShiftSwapModal = ({ employees, shifts, onSwap, onClose }) => {
  const [employee1, setEmployee1] = useState("");
  const [employee2, setEmployee2] = useState("");
  const [shift1, setShift1] = useState("");
  const [shift2, setShift2] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);

  const addDate = (e) => {
    const date = e.target.value;
    if (date && !selectedDates.includes(date)) {
      setSelectedDates([...selectedDates, date]);
    }
  };

  const removeDate = (d) => {
    setSelectedDates(selectedDates.filter(x => x !== d));
  };
  

  const handleSwap = () => {
    if (!employee1 || !employee2 || !shift1 || !shift2 || selectedDates.length === 0) {
      toast.error("Please fill all fields");
      return;
    }

    onSwap({
      employee1,
      employee2,
      shift1,
      shift2,
      dates: selectedDates
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal">

        <h2>Swap Shifts</h2>
 <div className="form-item">
        <label>Employee A</label>
        <select value={employee1} onChange={(e) => setEmployee1(e.target.value)}>
          <option value="">Select Employee</option>
          {employees.map(emp => (
            <option key={emp.id} value={emp.id}>
              {emp.first_name} {emp.last_name}
            </option>
          ))}
        </select>
      </div>
       <div className="form-item">

        <label>Shift for Employee A</label>
        <select value={shift1} onChange={(e) => setShift1(e.target.value)}>
          <option value="">Select Shift</option>
          {shifts.map(sh => (
            <option key={sh.id} value={sh.id}>{sh.name}</option>
          ))}
        </select>
</div>
 <div className="form-item">
        <label>Employee B</label>
        <select value={employee2} onChange={(e) => setEmployee2(e.target.value)}>
          <option value="">Select Employee</option>
          {employees.map(emp => (
            <option key={emp.id} value={emp.id}>
              {emp.first_name} {emp.last_name}
            </option>
          ))}
        </select>
</div>
 <div className="form-item">
        <label>Shift for Employee B</label>
        <select value={shift2} onChange={(e) => setShift2(e.target.value)}>
          <option value="">Select Shift</option>
          {shifts.map(sh => (
            <option key={sh.id} value={sh.id}>{sh.name}</option>
          ))}
        </select>
</div>
 <div className="form-item">
        <label>Select Dates</label>
        <input type="date" onChange={addDate} />

        <div className="selected-dates">
          {selectedDates.map(date => (
            <span key={date} onClick={() => removeDate(date)}>
              {date} ×
            </span>
          ))}
        </div>
      </div>
<div className="modal-actions">
        <button onClick={handleSwap}>Swap</button>
        <button onClick={onClose}>Cancel</button>
</div>
      </div>
    </div>
  );
};

export default ShiftSwapModal;
